import React, { memo } from 'react'

interface VisibilityIconProps {
  size?: number
  className?: string
}

export const VisibilityIcon: React.FC<VisibilityIconProps> = memo(
  ({ size = 16, className }) => (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M8.00059 10.666C8.83392 10.666 9.54225 10.3743 10.1256 9.79102C10.7089 9.20768 11.0006 8.49935 11.0006 7.66602C11.0006 6.83268 10.7089 6.12435 10.1256 5.54102C9.54225 4.95768 8.83392 4.66602 8.00059 4.66602C7.16725 4.66602 6.45892 4.95768 5.87559 5.54102C5.29225 6.12435 5.00059 6.83268 5.00059 7.66602C5.00059 8.49935 5.29225 9.20768 5.87559 9.79102C6.45892 10.3743 7.16725 10.666 8.00059 10.666ZM8.00059 9.46602C7.50059 9.46602 7.07559 9.29102 6.72559 8.94102C6.37559 8.59102 6.20059 8.16602 6.20059 7.66602C6.20059 7.16602 6.37559 6.74102 6.72559 6.39102C7.07559 6.04102 7.50059 5.86602 8.00059 5.86602C8.50059 5.86602 8.92559 6.04102 9.27559 6.39102C9.62559 6.74102 9.80059 7.16602 9.80059 7.66602C9.80059 8.16602 9.62559 8.59102 9.27559 8.94102C8.92559 9.29102 8.50059 9.46602 8.00059 9.46602ZM8.00059 12.666C6.5117 12.666 5.15336 12.266 3.92559 11.466C2.69781 10.666 1.72836 9.61046 1.01725 8.29935C0.961697 8.19935 0.92003 8.09657 0.892253 7.99102C0.864475 7.88546 0.850586 7.77713 0.850586 7.66602C0.850586 7.5549 0.864475 7.44657 0.892253 7.34102C0.92003 7.23546 0.961697 7.13268 1.01725 7.03268C1.72836 5.72157 2.69781 4.66602 3.92559 3.86602C5.15336 3.06602 6.5117 2.66602 8.00059 2.66602C9.48947 2.66602 10.8478 3.06602 12.0756 3.86602C13.3034 4.66602 14.2728 5.72157 14.9839 7.03268C15.0395 7.13268 15.0811 7.23546 15.1089 7.34102C15.1367 7.44657 15.1506 7.5549 15.1506 7.66602C15.1506 7.77713 15.1367 7.88546 15.1089 7.99102C15.0811 8.09657 15.0395 8.19935 14.9839 8.29935C14.2728 9.61046 13.3034 10.666 12.0756 11.466C10.8478 12.266 9.48947 12.666 8.00059 12.666Z"
        fill="currentColor"
      />
    </svg>
  ),
)
